import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

// Simple auth context placeholder
interface MyAuthContext {
  isAuthenticated: boolean;
}

export const Route = createRootRouteWithContext<MyAuthContext>()({
  component: AdminLayout,
});

function AdminLayout() {
  // Here you could add admin-specific layout like a sidebar
  return (
    <div className="p-4">
      <Outlet />
    </div>
  );
}
